module.exports = __webpack_public_path__ + "img/btn_auto_spin.0cfebcd6.png";